import React, { useState, useEffect } from 'react';
import { Box, Grid, TextField, Typography, Button, Paper, InputLabel, Select, Alert } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import FormControl from '@mui/material/FormControl';
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import MenuItem from '@mui/material/MenuItem';
import Switch from "@mui/material/Switch";
import { useMember } from '../context/MemberProfileContext';
import { useAuth } from '../hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import DeleteIcon from '@mui/icons-material/Delete';
import { updateHouseholdMembers } from '../api/memberServices';



function HouseholdMembers() {
  const { memberProfile, setMemberProfile, personName } = useMember();
  const [formState, setFormState] = useState({
    ...memberProfile,
    spouse: memberProfile.spouse || {}, // Ensure spouse is initialized as an object
  });
  const [studentFields, setStudentFields] = useState(memberProfile.children);
  const [addPeople, setAddPeople] = useState(0);
  const [addSpouse, setAddSpouse] = useState(""); // State to track if spouse is added
  const { accessToken, signOut, handleLogout } = useAuth();
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [genders, setGenders] = useState(["Male", "Female"])
  const [isEditMode, setIsEditMode] = useState(false); //Use to edit the address
  const [addressModified, setAddressModified] = useState(false);
  const [address, setAddress] = useState({
    streetAddress: '',
    city: '',
    state: '',
    postalCode: ''
  });

  
  

  //console.log("Entry Household Members form 2:", formState);

  const navigate = useNavigate();

  useEffect(() => {
    setFormState(memberProfile);
    console.log("Entry Household Member data at the beginning:", memberProfile);
  }, []);

  const handleInputChange = (section, field, value) => {
    setFormState((prevState) => ({
      ...prevState,
      [section]: {
        ...prevState[section],
        [field]: value,
      },
    }));
  };

  const checkoutHandler = (e) => {
    e.preventDefault();
    handleSave();
  };
  
   //setMemberProfile(formState);
  const handleSave = async (e) => {
    if (formState.primary.email === formState.spouse.email) {
      setError("Parent and spouse email addresses cannot be the same.");
      return;
    }
    if (formState.primary.mobileNumber === formState.spouse.mobileNumber) {
      setError("Parent and spouse mobile numbers cannot be the same.");
      return;
    }
    const mobileNumberRegex = /^\d+$/;
    if ((formState.primary.mobileNumber && !mobileNumberRegex.test(formState.primary.mobileNumber) ) 
        || (formState.spouse.mobileNumber && !mobileNumberRegex.test(formState.spouse.mobileNumber)) ) {
      setError("Mobile numbers can only contain digits.");
      return;
    }
    try {
          // Change password and call event registration system      
          const { data, response } = await updateHouseholdMembers(accessToken, formState);  
          console.log("After update:", response, formState);
 
       
          if (response.ok) {
            setSuccess("Household information changed successfully!");
            navigate('/EventTypesForm');
            setError("");
          } else {
            if (response.status === 400) {
              setError(data.message );
              console.log("Error in response:", data);

              //setError("Bad request. Invalid Address: ", response.message || response.data);
            } else if (response.status === 401) {
              setError("Unauthorized. Please log in again.");
            } else if (response.status === 403) {
              setError("Access token expired. Please log in again.");
              signOut();
              //handleLogout();
              navigate('/');
            } 
            else if (response.status === 500) {
              setError("Server error. Please try again later.");
            } else {
              setError( "Failed to change Household data.");
            }
          }
        } catch (err) {
          setError("An error occurred. Please try again." + err);
        }

      };
    
      function peopleSwitchHandler(e) {
        handleAddFields();
        setAddPeople(e.target.checked);
    };
    function spouseSwitchHandler(e) {
      setAddSpouse(e.target.checked);
  };
      const handleEditToggle = () => {
        setIsEditMode(!isEditMode);
        setAddressModified(true); // Address is modified
        formState.addressModified = true; // Address is modified
      };

   
    
  const handleCancel = () => {
    navigate('/EventTypesForm');
    // Add any additional save logic here, such as API calls
  };

  const handleStudentChange = (e, index) => {
    //    console.log("Event data in Student handle form :", (studentFields));        
    let newForm = [...studentFields];
    newForm[index][e.target.name] = e.target.value;
    setStudentFields(newForm);
    formState.children = newForm;
    memberProfile.children = newForm;
  }
  const handleAddFields = () => {
    setStudentFields([...studentFields, {
      memberType: "child", firstName: "", lastName: "", gender: "", email: "", mobileNumber: ""
    }]);
  };

  const handleRemoveFields = (index) => {
    const values = [...studentFields];
    values.splice(index, 1);
    setStudentFields(values);
    formState.children = values;
    memberProfile.children = values;
  };


  return (
    <Box p={4}>
      <Grid item xs={12}>
          <Paper elevation={3}>
            <Box style={{ padding: '8px', backgroundColor: '#673ab7', color: 'white' }} elevation={3}>
              <Typography variant="h7" align="left" gutterBottom>
                <b>Household Members Information</b>
              </Typography>
            </Box>
          </Paper>
        </Grid> 
    <form onSubmit={checkoutHandler}>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Typography variant="subtitle1"><b>Parent Information</b></Typography>          
          <TextField
            label="First Name"
            requried
            name="firstName"
            value={formState.primary.firstName}
            onChange={(e) => handleInputChange('primary', 'firstName', e.target.value)}
            fullWidth
            margin="normal"
          />
          <TextField
            required
            label="Last Name"
            name="lastName"
            value={formState.primary.lastName}
            onChange={(e) => handleInputChange('primary', 'lastName', e.target.value)}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Mobile Number"
            disabled
            value={formState.primary.mobileNumber}
            onChange={(e) => handleInputChange('primary', 'mobileNumber', e.target.value)}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Email"
            value={formState.primary.email}
            disabled
            onChange={(e) => handleInputChange('primary', 'email', e.target.value)}
            fullWidth
            margin="normal"
          />
        </Grid>
        </Grid>
        <Grid container spacing={2}>
        <Grid item xs={12}>
          <Paper elevation={3}>
            <Box style={{ padding: '8px', backgroundColor: '#673ab7', color: 'white' }} elevation={3}>
              <Typography variant="h7" align="left" gutterBottom>
                <b>Spouse Information</b>
              </Typography>
            </Box>
          </Paper>
        </Grid>       
        <div><br /></div>
          <Grid container justifyContent="center" alignItems="center" >
            <Grid item>
            {(!formState.spouse.firstName && !formState.spouse.lastName) && (
              <FormGroup>
                <FormControlLabel control={<Switch />} label="Add Spouse (Optional)" size="small" onChange={spouseSwitchHandler} />
              </FormGroup>
            )}
            </Grid>
          </Grid>
             
        {((addSpouse || formState.spouse.firstName || formState.spouse.lastName)  && 
        <Grid item xs={12} sm={6}>
          <Typography variant="subtitle1"><b>Spouse Information</b></Typography>
          <TextField
            label="First Name"
            name="firstName"
            required
            value={formState.spouse.firstName}
            onChange={(e) => handleInputChange('spouse', 'firstName', e.target.value)}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Last Name"
            name="lastName"
            required
            value={formState.spouse.lastName}
            onChange={(e) => handleInputChange('spouse', 'lastName', e.target.value)}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Mobile Number"
            type="number"
            name="mobileNumber"
            required
            value={formState.spouse.mobileNumber}
            onChange={(e) => handleInputChange('spouse', 'mobileNumber', e.target.value)}
            fullWidth
            margin="normal"
            disabled={formState.spouse.status === 'ACTIVE'}
          />
          <TextField
            label="Email"
            type="email"
            name="email"
            required
            value={formState.spouse.email}
            onChange={(e) => handleInputChange('spouse', 'email', e.target.value)}
            fullWidth
            margin="normal"
            disabled={formState.spouse.status === 'ACTIVE'}
          />
        </Grid>
            )}
        <div><br /></div>
        <div><br /></div>
        <Grid container spacing={2}>
        <Grid item xs={12}>
          <Paper elevation={3}>
            <Box style={{ padding: '8px', backgroundColor: '#673ab7', color: 'white' }} elevation={3}>
              <Typography variant="h7" align="left" gutterBottom>
                <b>Add/Edit Balavihar Children Information</b>
              </Typography>
            </Box>
          </Paper>
        </Grid>       
        <div><br /></div>
          <Grid container justifyContent="center" alignItems="center" >
            <Grid item>
            {studentFields.length === 0 && (
              <FormGroup>
                <FormControlLabel control={<Switch />} label="Add Balavihar Children" size="small" onChange={peopleSwitchHandler} />
              </FormGroup>
            )}
            </Grid>
          </Grid>      

        <Grid item xs={12} sm={12}>


        {studentFields && studentFields.map((studentFields, index) => (
          <div key={index} align="left">
            <div><br /></div>

        <Paper elevation={3}>

            <Typography variant="subtitle1"><b>Child Information {index + 1}</b></Typography>
            <Grid item xs={12} sm={6}>
            <TextField
              required
              label="First Name"
              name="firstName"
              value={studentFields.firstName}
              onChange={(e) => handleStudentChange(e, index)}
              fullWidth
              margin="normal"
            />
            </Grid>
            <Grid item xs={12} sm={6}>
            <TextField
              required
              label="Last Name"
              name="lastName"
              value={studentFields.lastName}
              onChange={(e) => handleStudentChange(e, index)}
              fullWidth
              margin="normal"
            />
            </Grid>
            <Grid item xs={12} sm={6}>                                                            
                  <FormControl variant="outlined" sx={{ m: 1, minWidth: 150 }} size="normal">
                      <InputLabel id="demo-simple-select-standard-label">Gender</InputLabel>
                      <Select
                          required
                          id="standard"
                          name="gender"
                          fullwidth
                          value={studentFields.gender}
                          onChange={(e) => handleStudentChange(e, index)}
                          label="gender"
                      >
                          {genders.map((item, index) =>
                          <MenuItem key={index} value={item}>{item}</MenuItem>
                          )}                                                                        
                      </Select>
                  </FormControl>                                                              
              </Grid>
            
            <Grid item xs={12} sm={6}>
            <TextField
              label="Mobile Number"
              name="mobileNumber"
              value={studentFields.mobileNumber}
              onChange={(e) => handleStudentChange(e, index)}
              fullWidth
              margin="normal"
            />
            </Grid>
            <Grid item xs={12} sm={6}>
            <TextField
              label="Email"
              type="email"
              name="email"
              value={studentFields.email}
              onChange={(e) => handleStudentChange(e, index)}
              fullWidth
              margin="normal"
            />
            </Grid>
          
      <Grid item xs={12} sm={12}>
        <Paper elevation={3} variant="outlined">
          <b>Add/Delete/Edit Participant</b>
          {index >= 0 ?
            <IconButton onClick={() => handleRemoveFields(index)}>
              <DeleteIcon />
            </IconButton> : ''
          }
          <IconButton onClick={() => handleAddFields(index)}>
            <PersonAddIcon />
          </IconButton>
        </Paper>
        <div><br /></div>
      </Grid>
      </Paper>
       </div>       
        )
        
        )}
        </Grid>
        </Grid>
        </Grid>
        <div><br /></div>
        <Grid container spacing={2}>
        <Grid item xs={12}>
      <Paper elevation={3}>
        <Box style={{ padding: '8px', backgroundColor: '#673ab7', color: 'white' }} elevation={3}>
          <Typography variant="h7" align="left" gutterBottom>
            <b>Household Address</b>
          </Typography>
        </Box>
      </Paper>
      </Grid>
        {isEditMode ? (
          <>
     <Grid item xs={12} sm={6}>
                  <Paper elevation={3}>
                      <TextField
                          required
                          id="streetAddress1 "
                          label="Address Line 1"
                          name="streetAddress"
                          variant="outlined"
                          fullWidth
                          value={formState.houseHold.streetAddress}
                          onChange={(e) => handleInputChange('houseHold', 'streetAddress', e.target.value)}
                      />
                      </Paper>
                  </Grid>                   
                  <Grid item xs={12} sm={6}>
                  <Paper elevation={3}>
                      <TextField                          
                          id="city"
                          label="City"
                          name="city"
                          variant="outlined"
                          fullWidth
                          value={formState.houseHold.city}
                          onChange={(e) => handleInputChange('houseHold', 'city', e.target.value)}
                          />
                      </Paper>
                  </Grid>  
              <Grid item xs={12} sm={6}>
            
            <FormControl fullWidth margin="normal" variant="outlined">
              <InputLabel>State</InputLabel>
              <Select
                value={formState.houseHold.state}
                required
                onChange={(e) => handleInputChange('houseHold', 'state', e.target.value)}
                name="state"
                label="state"
              >
                <MenuItem value="AL">Alabama</MenuItem>
                <MenuItem value="AK">Alaska</MenuItem>
                <MenuItem value="AZ">Arizona</MenuItem>
                <MenuItem value="AR">Arkansas</MenuItem>
                <MenuItem value="CA">California</MenuItem>
                <MenuItem value="CO">Colorado</MenuItem>
                <MenuItem value="CT">Connecticut</MenuItem>
                <MenuItem value="DE">Delaware</MenuItem>
                <MenuItem value="FL">Florida</MenuItem>
                <MenuItem value="GA">Georgia</MenuItem>
                <MenuItem value="HI">Hawaii</MenuItem>
                <MenuItem value="ID">Idaho</MenuItem>
                <MenuItem value="IL">Illinois</MenuItem>
                <MenuItem value="IN">Indiana</MenuItem>
                <MenuItem value="IA">Iowa</MenuItem>
                <MenuItem value="KS">Kansas</MenuItem>
                <MenuItem value="KY">Kentucky</MenuItem>
                <MenuItem value="LA">Louisiana</MenuItem>
                <MenuItem value="ME">Maine</MenuItem>
                <MenuItem value="MD">Maryland</MenuItem>
                <MenuItem value="MA">Massachusetts</MenuItem>
                <MenuItem value="MI">Michigan</MenuItem>
                <MenuItem value="MN">Minnesota</MenuItem>
                <MenuItem value="MS">Mississippi</MenuItem>
                <MenuItem value="MO">Missouri</MenuItem>
                <MenuItem value="MT">Montana</MenuItem>
                <MenuItem value="NE">Nebraska</MenuItem>
                <MenuItem value="NV">Nevada</MenuItem>
                <MenuItem value="NH">New Hampshire</MenuItem>
                <MenuItem value="NJ">New Jersey</MenuItem>
                <MenuItem value="NM">New Mexico</MenuItem>
                <MenuItem value="NY">New York</MenuItem>
                <MenuItem value="NC">North Carolina</MenuItem>
                <MenuItem value="ND">North Dakota</MenuItem>
                <MenuItem value="OH">Ohio</MenuItem>
                <MenuItem value="OK">Oklahoma</MenuItem>
                <MenuItem value="OR">Oregon</MenuItem>
                <MenuItem value="PA">Pennsylvania</MenuItem>
                <MenuItem value="RI">Rhode Island</MenuItem>
                <MenuItem value="SC">South Carolina</MenuItem>
                <MenuItem value="SD">South Dakota</MenuItem>
                <MenuItem value="TN">Tennessee</MenuItem>
                <MenuItem value="TX">Texas</MenuItem>
                <MenuItem value="UT">Utah</MenuItem>
                <MenuItem value="VT">Vermont</MenuItem>
                <MenuItem value="VA">Virginia</MenuItem>
                <MenuItem value="WA">Washington</MenuItem>
                <MenuItem value="WV">West Virginia</MenuItem>
                <MenuItem value="WI">Wisconsin</MenuItem>
                <MenuItem value="WY">Wyoming</MenuItem>
              </Select>              
            </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
                  <Paper elevation={3}>
                      <TextField
                          required
                          id="Zip Code"
                          label="Zip Code"
                          name="postalCode"
                          variant="outlined"
                          fullWidth
                          value={formState.houseHold.postalCode}
                          onChange={(e) => handleInputChange('houseHold', 'postalCode', e.target.value)}
                      />
                      </Paper>
                  </Grid> 
                  </>
        ) : (
          <>
            <Grid item xs={12}>
              <Typography variant="body1">
                {formState.houseHold.streetAddress}
              </Typography>
              <Typography variant="body1">
                {formState.houseHold.city}, {formState.houseHold.state} {formState.houseHold.postalCode}
              </Typography>
              <Box mt={2} display="flex" justifyContent="center">
                <Button variant="contained" color="primary" onClick={handleEditToggle}>
                  Modify
                </Button>
              </Box>
              
            </Grid>
          </>

        ) 
      }
      
    </Grid>
    <div><br /></div>

    <Paper elevation={3}>
        <Box style={{ padding: '1px', backgroundColor: '#673ab7', color: 'white' }} elevation={3}>
          <Typography variant="h7" align="left" gutterBottom>            
          </Typography>
        </Box>
      </Paper>
    <div><br /></div>

    <Grid container spacing={2}>
      <Box mt={2} display="flex" justifyContent="left">
        <Button variant="contained" color="primary" onClick={handleCancel} sx={{ mr: 4 }}>
          Cancel
        </Button>
      </Box>
      <Box mt={2} display="flex" justifyContent="center">
        <Button type="submit" variant="contained" color="primary" >
          Save
        </Button>
          {error && (
            <Grid item xs={12}>
              <Alert severity="error">{error}</Alert>
            </Grid>
          )}
      </Box>
    </Grid>
</form>
    </Box>
    
    
  );

}

export default HouseholdMembers;